var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import { StyleSheet } from 'aphrodite';
import { LBPlayer } from '../lb_player';
import { MediaBreakPointDown, MediaBreakPointUp } from '../styles';
import { LBPlayerContainer } from './lb_player_container';
export const LiveArchiveVideo = ({ liveLesson, onInit, onPlay, onTimeupdate, signedCookieService, }) => {
    const isInit = React.useRef(false);
    const [lbPlayerCtx, setLbPlayerCtx] = React.useState(null);
    const [playButtonVisible, setPlayButtonVisible] = React.useState(true);
    React.useEffect(() => {
        if (!lbPlayerCtx) {
            return;
        }
        if (!isInit.current) {
            isInit.current = true;
            // iOS側ではiOS独自の全画面になっていて、全画面から離脱をする時動画が停止される。
            // iOS側で全画面離脱を感知できないので、動画の再生状態に合わせてVjsVideoControllerの表示を調整している。
            lbPlayerCtx.on('pause', () => {
                const VjsVideoController = lbPlayerCtx.getChild('VjsVideoController');
                VjsVideoController.setIsPaused(true);
            });
            lbPlayerCtx.on('play', () => {
                const VjsVideoController = lbPlayerCtx.getChild('VjsVideoController');
                VjsVideoController.setIsPaused(false);
                onPlay(lbPlayerCtx.currentTime());
            });
            lbPlayerCtx.on('timeupdate', () => onTimeupdate(lbPlayerCtx.currentTime()));
            playVideo();
            onInit();
        }
    }, [lbPlayerCtx]);
    const playVideo = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!lbPlayerCtx) {
            return;
        }
        // 動画を閲覧するための署名付きCookie取得
        yield signedCookieService.fetchSignedCookies();
        setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                yield lbPlayerCtx.play();
                setPlayButtonVisible(false);
            }
            catch (_a) {
                setPlayButtonVisible(true);
            }
        }), 300);
    });
    const lbVideoOptions = (src) => {
        return {
            sources: [
                {
                    src,
                    type: 'application/x-mpegURL',
                },
            ],
            preload: 'auto',
            playsinline: true,
            controls: true,
            controlBar: {
                playToggle: false,
                volumePanel: false,
                muteToggle: false,
                fullscreenToggle: false,
                pictureInPictureToggle: false,
            },
        };
    };
    const videoOperationProps = {
        onClickExitInnerFullScreen: () => { },
        onClickPrev: () => { },
        onClickNext: () => { },
        isFirstLesson: true,
        isLastLesson: true,
        showAutoplayToggle: false,
        showBackButton: false,
        isAlwaysShowStepButtons: true,
    };
    return (React.createElement(LBPlayerContainer, { classObject: styles.container, playButtonVisible: playButtonVisible, onClickPlayButton: playVideo },
        React.createElement(LBPlayer, { getPlayer: (player) => setLbPlayerCtx(player), videoOptions: lbVideoOptions(liveLesson.archiveVideo.hlsURL), operationOptions: videoOperationProps })));
};
const styles = StyleSheet.create({
    container: {
        [MediaBreakPointDown.SM]: {
            width: '100%',
            top: '-2px',
            margin: '0 auto',
        },
        [MediaBreakPointUp.XL]: {
            marginBottom: 24,
        },
    },
});
